/**
 * Scroll Animations JavaScript
 * Intersection Observer voor scroll-triggered animaties
 */

(function() {
  'use strict';

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      // Show everything immediately
      document.querySelectorAll('[data-animate], [data-animate-stagger], [data-animate-products], .section-bg').forEach(el => {
        el.classList.add('is-visible');
      });
      return;
    }

    initScrollAnimations();
    initProductAnimations();
    initSectionBackgrounds();
  }

  /**
   * General scroll animations
   */
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-animate], [data-animate-stagger]');
    
    if (!animatedElements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Unobserve after animation (one-time trigger)
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1
    });

    animatedElements.forEach(el => observer.observe(el));
  }

  /**
   * Product grid animations
   */
  function initProductAnimations() {
    const productGrids = document.querySelectorAll('.product-grid, [data-animate-products]');
    
    if (!productGrids.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -5% 0px',
      threshold: 0.05
    });

    productGrids.forEach(el => {
      // Add animation attribute if not present
      if (!el.hasAttribute('data-animate-products')) {
        el.setAttribute('data-animate-products', '');
      }
      observer.observe(el);
    });
  }

  /**
   * Section background fade-in
   */
  function initSectionBackgrounds() {
    const sectionBgs = document.querySelectorAll('.section-bg');
    
    if (!sectionBgs.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          // Allow fade out when leaving viewport
          entry.target.classList.remove('is-visible');
        }
      });
    }, {
      root: null,
      rootMargin: '-10% 0px -10% 0px',
      threshold: 0.2
    });

    sectionBgs.forEach(el => observer.observe(el));
  }

  /**
   * Auto-apply animations to common elements
   * EXCLUDE: header, footer, hero sections
   */
  function autoApplyAnimations() {
    // Section headers - but NOT in header/footer/hero
    document.querySelectorAll('.section-header:not([data-animate])').forEach(el => {
      // Skip if inside header, footer, or hero
      if (el.closest('.header, .footer, .site-header-container, .hero-map, [data-header]')) return;
      el.setAttribute('data-animate', 'fade-up');
    });

    // Subheadings - exclude header/footer/hero
    document.querySelectorAll('.subheading:not([data-animate])').forEach(el => {
      if (el.closest('.header, .footer, .site-header-container, .hero-map, [data-header]')) return;
      el.setAttribute('data-animate', 'fade-up');
    });

    // NOTE: h2 headings are NOT auto-animated — they should always be visible immediately.
  }

  // Run auto-apply
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoApplyAnimations);
  } else {
    autoApplyAnimations();
  }

})();
